import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AppComponent } from './app.component';
import { SigninComponent } from './auth/signin/signin.component';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from './auth/auth.service';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './auth/auth-guard.service';
import { HeaderComponent } from './header/header.component';
import { DropdownDirective } from './shared-directives/dropdown.directive';
import { AuthAntiGuard } from './auth/auth-anti-guard.service';
import { AuthBrokerGuard } from './auth/auth-broker-guard.service';
import { ConnectionService } from './shared-services/connection.service';
import { FooterComponent } from './footer/footer.component';
import { GoogleAnalyticsService } from './analytics/google.analytics.service';
import { RouterModule } from '@angular/router';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { MultiRiskComponent } from './admin/multi-risk/multi-risk.component';
import { ToastService } from './shared-services/toast.service';
import { ApplicationComponent } from './application/application/application.component';
import { BusinessInformationComponent } from './application/application/business-information/business-information.component';
import { OwnersInformationComponent } from './application/application/owners-information/owners-information.component';
import { SummaryDialogComponent } from './application/application/summary-dialog/summary-dialog.component';
import { OffersComponent } from './application/offers/offers.component';
import { InvoiceComponent } from './application/invoice/invoice.component';
import { SelectOfferDialogComponent } from './application/invoice/select-offer-dialog/select-offer-dialog.component';
import { DocuSentComponent } from './application/docu-sent/docu-sent.component';
import { DocuSignComponent } from './application/docu-sign/docu-sign.component';
import { BankInfoComponent } from './application/bank-info/bank-info.component';
import { ImpersonateComponent } from './admin/impersonate/impersonate.component';
import { VendorsComponent } from './vendors/vendors.component';
import { ApplicationsListComponent } from './applications-list/applications-list.component';
import { ApplicationListFundedTabComponent } from './applications-list/application-list-funded-tab/application-list-funded-tab.component';
// tslint:disable-next-line: max-line-length
import { ApplicationListContractSignedTabComponent } from './applications-list/application-list-contract-signed-tab/application-list-contract-signed-tab.component';
// tslint:disable-next-line: max-line-length
import { ApplicationListApplicationTabComponent } from './applications-list/application-list-application-tab/application-list-application-tab.component';
import { ArraySortPipe } from './shared-pipes/array.sort.pipe';
import { IndustyPipe } from './shared-pipes/industry.pipe';
import { StatePipe } from './shared-pipes/state.pipe';
import { ErrorDialogComponent } from './utils/error-dialog/error-dialog.component';
import { LoadingScreenComponent } from './utils/loading-screen/loading-screen.component';
import { LoadingScreenInterceptor } from './shared-interceptors/loading.interceptor';
import { AnalyticsInterceptor } from './shared-interceptors/analytics.interceptor';
import { AchConverterComponentComponent } from './admin/ach-converter-component/ach-converter-component.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CustomerSupportComponent } from './customer-support/customer-support.component';
import { UploadDocumentComponent } from './utils/upload-document/upload-document.component';
import { DocumentsTableComponent } from './utils/documents-table/documents-table.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { AboutComponent } from './about/about.component';
import { ListSideBarComponent } from './applications-list/list-side-bar/list-side-bar.component';
import { ApplicationListBrokerVendorReportTabComponent } from './applications-list/application-list-broker-vendor-report-tab/application-list-broker-vendor-report-tab.component';
import { ApplicationListTerminatedCommissionTabComponent } from './applications-list/application-list-terminated-commission-tab/application-list-terminated-commission-tab.component';
import { ApplicationListChartsTabComponent } from './applications-list/application-list-charts-tab/application-list-charts-tab.component';
import { HeaderSendApplicationDialogComponent } from './header/header-send-application-dialog/header-send-application-dialog.component';
import { HeaderSendUpsellApplicationComponent } from './header/header-send-upsell-application/header-send-upsell-application.component';
import { AgreementComponent } from './application/application/agreement/agreement.component';
import { ApplicationTokenComponent } from './application-token/application-token/application-token.component';
import { AuthTokenGuard } from './auth/auth-token-guard.service';
import { OffersTokenComponent } from './application-token/offers-token/offers-token.component';
import { SummaryComponent } from './application/summary/summary.component';
import { UploadLicenseTokenComponent } from './application-token/upload-license-token/upload-license-token.component';
import { CreateSendContractComponent } from './application/summary/create-send-contract/create-send-contract.component';
import { SubmitInvoiceComponent } from './application/summary/submit-invoice/submit-invoice.component';
import { ContractStatusComponent } from './application/summary/contract-status/contract-status.component';
import { InvoiceReviewComponent } from './application/summary/invoice-review/invoice-review.component';
import { FundingPendingComponent } from './application/summary/funding-pending/funding-pending.component';
import { FundedComponent } from './application/summary/funded/funded.component';
import { AdditionaAddCoSignerComponent } from './application/summary/additional-options/additional-add-co-signer/additional-add-co-signer.component';
import { AdditionalResendDlLinkComponent } from './application/summary/additional-options/additional-resend-dl-link/additional-resend-dl-link.component';
import { AdditionaPaymentCalculatorComponent } from './application/summary/additional-options/additional-payment-calculator/additional-payment-calculator.component';
import { ApplicationDetailsNotesComponent } from './application/summary/application-details/application-details-notes/application-details-notes.component';
import { ApplicationDetailsHistoryComponent } from './application/summary/application-details/application-details-history/application-details-history.component';
import { AdditionaAddCoSignerEmailComponent } from './application/summary/additional-options/additional-add-co-signer-email/additional-add-co-signer-email.component';
import { EditOwnerEmailComponent } from './application/summary/owner-info/edit-owner-email/edit-owner-email.component';
import { SecurityInterceptor } from './shared-interceptors/security.interceptor';
import { ExpiredLoginDialogComponent } from './utils/expired-login-dialog/expired-login-dialog.component';
import { DataErrorComponent } from './application/summary/data-error/data-error.component';
import { AdditionalDownloadPOComponent } from './application/summary/additional-options/additional-download-po/additional-download-po.component';
import { AdditionalResendContractComponent } from './application/summary/additional-options/additional-resend-contract/additional-resend-contract.component';
import { GeneralErrorComponent } from './error/general-error/general-error.component';
import { GuidedTourModule, GuidedTourService } from 'ngx-guided-tour';
import { PricingComponent } from './admin/pricing-tool/pricing-tool.component';
import { DriverLicenseDeclinedComponent } from './application/summary/driver-license-declined/driver-license-declined.component';
import { MultiRiskItemComponent } from './admin/multi-risk/multi-risk-item/multi-risk-item.component';
import { PricingItemComponent } from './admin/pricing-tool/pricing-item/pricing-item.component';
import { ArrayFilterPipe } from './shared-pipes/array.filter.pipe';
import { ArrayLikePipe } from './shared-pipes/array.like.pipe';
import { ApplicationDetailsRiskComponent } from './application/summary/application-details/application-details-risk/application-details-risk.component';
import { HeaderVendorBrockerSelectDialogComponent } from './header/header-vendor-brocker-select-dialog/header-vendor-brocker-select-dialog.component';
import { MaxOfferToolComponent } from './admin/max-offer-tool/max-offer-tool.component';
import { MaxOfferItemComponent } from './admin/max-offer-tool/max-offer-item/max-offer-item.component';
import { TermToolComponent } from './admin/term-tool/term-tool.component';
import { TermItemComponent } from './admin/term-tool/term-item/term-item.component';
import { DataRobotToolComponent } from './admin/data-robot-tool/data-robot-tool.component';
import { DataRobotItemComponent } from './admin/data-robot-tool/data-robot-item/data-robot-item.component';
import { VendorListComponent } from './vendors/vendor-list/vendor-list.component';
import { VendorListItemComponent } from './vendors/vendor-list-item/vendor-list-item.component';
import { AdditionalResubmitComponent } from './application/summary/additional-options/additional-resubmit/additional-resubmit.component';
import { AddOwnerTokenComponent } from './application-token/add-owner-token/add-owner-token.component';
import { BankInfoTokenComponent } from './application-token/bank-info-token/bank-info-token.component';
import { ContractTokenComponent } from './application-token/contract-token/contract-token.component';
import { DocuSignCompletedComponent } from './application/docu-sign-completed/docu-sign-completed.component';
import { OffersSelectionTokenComponent } from './application-token/offers-selection-token/offers-selection-token.component';
import { OffersSelectionBankInfoTokenComponent } from './application-token/offers-selection-bank-info-token/offers-selection-bank-info-token.component';
import { AdditionalChangeSalespersonComponent } from './application/summary/additional-options/additional-change-salesperson/additional-change-salesperson.component';
import { FinicityLinkComponent } from './application-token/finicity-link/finicity-link.component';
import { AppHeaderComponent } from './application/application/app-header/app-header.component';
import { DragDropComponent } from './application/application/drag-drop/drag-drop.component';
import { DndDirective } from './shared-directives/dnd.directive';
import { AchInformationComponent } from './application/application/ach-information/ach-information.component';
import { EquipmentInformationComponent } from './application/application/equipment-information/equipment-information.component';
import { ApprovalComponent } from './application/approval/approval.component';
import { CoSignerInformationComponent } from './application/application/co-signer-information/co-signer-information.component';
import { FinicityComponent } from './application/application/finicity/finicity.component';
import { InstantResultsComponent } from './application/application/instant-results/instant-results.component';
import { SummaryDeclinedComponent } from './application/summary/summary-declined/summary-declined.component';
import { WhatMakesUsDifferentComponent } from './application/application/what-makes-us-different/what-makes-us-different.component';
import { CommentsSectionComponent } from './application/application/comments-section/comments-section.component';
import { DeclinedComponent } from './application/declined/declined.component';
import { SoleOwnerInformationComponent } from './application/application/sole-owner-information/sole-owner-information.component';
import { DeclineFinicityComponent } from './application/decline-finicity/decline-finicity.component';
import { DeclineDataErrorComponent } from './application/decline-data-error/decline-data-error.component';
import { VerifyInformationComponent } from './application/application/verify-information/verify-information.component';
import { PreApprovalComponent } from './application/summary/pre-approval/pre-approval.component';
import { AdditionalResendBankVerificationLinkComponent } from './application/summary/additional-options/additional-resend-bank-verification-link/additional-resend-bank-verification-link.component';
import { TokenErrorComponent } from './error/token-error/token-error.component';
import { UploadInvoiceComponent } from './application/invoice/upload-invoice/upload-invoice.component';
import { InvoiceUploaderComponent } from './application/invoice/upload-invoice/invoice-uploader/invoice-uploader.component';

export let options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    declarations: [
        AppComponent,
        SigninComponent,
        HomeComponent,
        HeaderComponent,
        DropdownDirective,
        FooterComponent,
        ResetPasswordComponent,
        MultiRiskComponent,
        ApplicationComponent,
        BusinessInformationComponent,
        OwnersInformationComponent,
        SummaryDialogComponent,
        OffersComponent,
        InvoiceComponent,
        SelectOfferDialogComponent,
        DocuSentComponent,
        DocuSignComponent,
        BankInfoComponent,
        ImpersonateComponent,
        ApplicationsListComponent,
        ApplicationListFundedTabComponent,
        ApplicationListContractSignedTabComponent,
        ApplicationListApplicationTabComponent,
        IndustyPipe,
        ArraySortPipe,
        ArrayFilterPipe,
        ArrayLikePipe,
        StatePipe,
        ErrorDialogComponent,
        LoadingScreenComponent,
        AchConverterComponentComponent,
        CustomerSupportComponent,
        UploadDocumentComponent,
        DocumentsTableComponent,
        PrivacyComponent,
        AboutComponent,
        ListSideBarComponent,
        ApplicationListBrokerVendorReportTabComponent,
        ApplicationListTerminatedCommissionTabComponent,
        ApplicationListChartsTabComponent,
        HeaderSendApplicationDialogComponent,
        HeaderSendUpsellApplicationComponent,
        AgreementComponent,
        ApplicationTokenComponent,
        OffersTokenComponent,
        SummaryComponent,
        UploadLicenseTokenComponent,
        CreateSendContractComponent,
        SubmitInvoiceComponent,
        ContractStatusComponent,
        InvoiceReviewComponent,
        FundingPendingComponent,
        FundedComponent,
        AdditionaAddCoSignerComponent,
        AdditionalResendDlLinkComponent,
        AdditionaPaymentCalculatorComponent,
        ApplicationDetailsNotesComponent,
        ApplicationDetailsHistoryComponent,
        AdditionaAddCoSignerEmailComponent,
        EditOwnerEmailComponent,
        ExpiredLoginDialogComponent,
        DataErrorComponent,
        AdditionalDownloadPOComponent,
        AdditionalResendContractComponent,
        DriverLicenseDeclinedComponent,
        VendorsComponent,
        HeaderVendorBrockerSelectDialogComponent,
        PricingComponent,
        MultiRiskItemComponent,
        PricingItemComponent,
        ApplicationDetailsRiskComponent,
        HeaderVendorBrockerSelectDialogComponent,
        MaxOfferToolComponent,
        MaxOfferItemComponent,
        TermToolComponent,
        TermItemComponent,
        DataRobotToolComponent,
        DataRobotItemComponent,
        GeneralErrorComponent,
        VendorListComponent,
        VendorListItemComponent,
        AdditionalResubmitComponent,
        AdditionalChangeSalespersonComponent,
        FinicityLinkComponent,
        PreApprovalComponent,
        AdditionalResendBankVerificationLinkComponent,
        AddOwnerTokenComponent,
        BankInfoTokenComponent,
        ContractTokenComponent,
        DocuSignCompletedComponent,
        OffersSelectionTokenComponent,
        OffersSelectionBankInfoTokenComponent,
        FinicityLinkComponent,
        AppHeaderComponent,
        DragDropComponent,
        DndDirective,
        AchInformationComponent,
        EquipmentInformationComponent,
        ApprovalComponent,
        CoSignerInformationComponent,
        FinicityComponent,
        InstantResultsComponent,
        SummaryDeclinedComponent,
        WhatMakesUsDifferentComponent,
        CommentsSectionComponent,
        DeclinedComponent,
        SoleOwnerInformationComponent,
        DeclineFinicityComponent,
        DeclineDataErrorComponent,
        VerifyInformationComponent,
        TokenErrorComponent,
        UploadInvoiceComponent,
        InvoiceUploaderComponent
    ],
    imports: [
        BrowserModule,
        RouterModule,
        HttpClientModule,
        FormsModule,
        AppRoutingModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        BsDatepickerModule.forRoot(),
        FontAwesomeModule,
        GuidedTourModule,
        NgxMaskModule.forRoot(options)
    ],
    providers: [
        AuthService,
        ConnectionService,
        GoogleAnalyticsService,
        AuthGuard,
        AuthAntiGuard,
        AuthTokenGuard,
        AuthBrokerGuard,
        ToastService,
        GuidedTourService,
        ArrayFilterPipe,
        ArraySortPipe,
        ArrayLikePipe,
        /*{
            provide: HTTP_INTERCEPTORS,
            useClass: SecurityInterceptor,
            multi: true
        },*/
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoadingScreenInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AnalyticsInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
